import Theme from './Theme'

export * from './Theme'
export default Theme

export * from './get-theme'
